import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SkuFormatterPipe } from './pipes/sku-formatter.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImagePipe } from './pipes/image.pipe';
import { IsMobileDirective } from './directives/is-mobile.directive';
import { IsTabletDirective } from './directives/is-tablet.directive';

@NgModule({
  declarations: [
    SkuFormatterPipe,
    ImagePipe,
    IsMobileDirective,
    IsTabletDirective,
  ],
  exports: [SkuFormatterPipe, ImagePipe, IsMobileDirective, IsTabletDirective],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  providers: [ImagePipe],
})
export class CoreModule {}
